(() => {
  if (window.HalmAblyftEvents) return;

  // Custom conversion goals configured in AbLyft.
  const HALM_VIEW_CART_GOAL = "custom-view-cart";
  const HALM_START_QUIZ_GOAL = "custom-start-quiz";

  const fireCustomEvent = (eventName) => {
    window.ablyft = window.ablyft || [];
    window.ablyft.push({
      eventType: "custom",
      eventName,
    });
  };

  window.HalmAblyftEvents = {
    fireCustomEvent,
    trackViewCart: () => fireCustomEvent(HALM_VIEW_CART_GOAL),
    trackStartQuiz: () => fireCustomEvent(HALM_START_QUIZ_GOAL),
  };
})();
